import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ExportProgress = {
    currentBatch: number;
    totalBatches?: number;
    loadedRecords: number;
    totalRecords?: number;
}

interface ExportDialogState {
    isDialogOpen: boolean;
    progress: ExportProgress | null;
}

type StateWithExportDialog = { exportDialog: ExportDialogState };

const initialState: ExportDialogState = {
    isDialogOpen: false,
    progress: null
};

const exportDialogSlice = createSlice({
    name: 'exportDialog',
    initialState,

    reducers: (create) => ({
        setExportDialogOpen: create.reducer((state, action: PayloadAction<boolean>) => {
            state.isDialogOpen = action.payload;
            if (!action.payload) {
                state.progress = null;
            }
        }),

        setExportProgress: create.reducer((state, action: PayloadAction<ExportProgress>) => {
            state.progress = action.payload;
        }),

        resetExportProgress: create.reducer((state) => {
            state.progress = null;
        })
    })
});

// eslint-disable-next-line no-restricted-syntax
export default exportDialogSlice.reducer;
export const selectIsDialogOpen = (state: StateWithExportDialog) => state.exportDialog.isDialogOpen;
export const selectExportProgress = (state: StateWithExportDialog) => state.exportDialog.progress;
export const { setExportDialogOpen, setExportProgress, resetExportProgress } = exportDialogSlice.actions;
